import { render, staticRenderFns } from "./createBlog.vue?vue&type=template&id=16980ebf&scoped=true&lang=html&"
import script from "./createBlog.vue?vue&type=script&lang=js&"
export * from "./createBlog.vue?vue&type=script&lang=js&"
import style0 from "./createBlog.vue?vue&type=style&index=0&id=16980ebf&lang=scss&scoped=true&"
import style1 from "./createBlog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16980ebf",
  null
  
)

export default component.exports